<template>
  <h3 class="headingLp">
    <span v-html="beforeText" v-if="beforeText" />
    <span class="color" v-if="spanText">{{ spanText }}</span
    ><span v-html="text"></span>
  </h3>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'HeadingLp',

  props: {
    beforeText: String,
    text: String,
    spanText: String
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.headingLp {
  font-size: 22px;
  line-height: 1.5;
  text-align: center;
  @include mixins.media() {
    font-size: 24px;
    line-height: 1;
  }
  &::after {
    content: '';
    display: block;
    margin: 18px auto 0;
    width: 44px;
    height: 2px;
    background-color: #29ccc3;
    @include mixins.media() {
      margin-top: 22px;
    }
  }
  > .color {
    color: #29ccc3;
  }
}
</style>
